// Русская локализация для MUI DataGrid
export const ruRU = {
  // Root
  noRowsLabel: 'Нет данных',
  noResultsOverlayLabel: 'Ничего не найдено',

  // Density selector toolbar button text
  toolbarDensity: 'Плотность',
  toolbarDensityLabel: 'Плотность',
  toolbarDensityCompact: 'Компактная',
  toolbarDensityStandard: 'Стандартная',
  toolbarDensityComfortable: 'Комфортная',

  // Columns selector toolbar button text
  toolbarColumns: 'Колонки',
  toolbarColumnsLabel: 'Выбрать колонки',

  // Filters toolbar button text
  toolbarFilters: 'Фильтры',
  toolbarFiltersLabel: 'Показать фильтры',
  toolbarFiltersTooltipHide: 'Скрыть фильтры',
  toolbarFiltersTooltipShow: 'Показать фильтры',
  toolbarFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} активных фильтров` : `${count} активный фильтр`,

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Поиск…',
  toolbarQuickFilterLabel: 'Поиск',
  toolbarQuickFilterDeleteIconLabel: 'Очистить',

  // Export selector toolbar button text
  toolbarExport: 'Экспорт',
  toolbarExportLabel: 'Экспорт',
  toolbarExportCSV: 'Скачать в CSV',
  toolbarExportPrint: 'Печать',
  toolbarExportExcel: 'Скачать в Excel',

  // Columns panel text
  columnsPanelTextFieldLabel: 'Найти колонку',
  columnsPanelTextFieldPlaceholder: 'Название колонки',
  columnsPanelDragIconLabel: 'Изменить порядок колонки',
  columnsPanelShowAllButton: 'Показать все',
  columnsPanelHideAllButton: 'Скрыть все',

  // Filter panel text
  filterPanelAddFilter: 'Добавить фильтр',
  filterPanelRemoveAll: 'Удалить все',
  filterPanelDeleteIconLabel: 'Удалить',
  filterPanelLogicOperator: 'Логический оператор',
  filterPanelOperator: 'Оператор',
  filterPanelOperatorAnd: 'И',
  filterPanelOperatorOr: 'Или',
  filterPanelColumns: 'Колонки',
  filterPanelInputLabel: 'Значение',
  filterPanelInputPlaceholder: 'Значение фильтра',

  // Filter operators text
  filterOperatorContains: 'содержит',
  filterOperatorEquals: 'равно',
  filterOperatorStartsWith: 'начинается с',
  filterOperatorEndsWith: 'заканчивается на',
  filterOperatorIs: 'равно',
  filterOperatorNot: 'не равно',
  filterOperatorAfter: 'после',
  filterOperatorOnOrAfter: 'на или после',
  filterOperatorBefore: 'до',
  filterOperatorOnOrBefore: 'на или до',
  filterOperatorIsEmpty: 'пусто',
  filterOperatorIsNotEmpty: 'не пусто',
  filterOperatorIsAnyOf: 'любое из',

  // Header filter operators text
  headerFilterOperatorContains: 'Содержит',
  headerFilterOperatorEquals: 'Равно',
  headerFilterOperatorStartsWith: 'Начинается с',
  headerFilterOperatorEndsWith: 'Заканчивается на',
  headerFilterOperatorIs: 'Равно',
  headerFilterOperatorNot: 'Не равно',
  headerFilterOperatorAfter: 'После',
  headerFilterOperatorOnOrAfter: 'На или после',
  headerFilterOperatorBefore: 'До',
  headerFilterOperatorOnOrBefore: 'На или до',
  headerFilterOperatorIsEmpty: 'Пусто',
  headerFilterOperatorIsNotEmpty: 'Не пусто',
  headerFilterOperatorIsAnyOf: 'Любое из',
  'headerFilterOperator=': 'Равно',
  'headerFilterOperator!=': 'Не равно',
  'headerFilterOperator>': 'Больше',
  'headerFilterOperator>=': 'Больше или равно',
  'headerFilterOperator<': 'Меньше',
  'headerFilterOperator<=': 'Меньше или равно',

  // Filter values text
  filterValueAny: 'любое',
  filterValueTrue: 'истина',
  filterValueFalse: 'ложь',

  // Column menu text
  columnMenuLabel: 'Меню',
  columnMenuShowColumns: 'Показать колонки',
  columnMenuManageColumns: 'Управление колонками',
  columnMenuFilter: 'Фильтр',
  columnMenuHideColumn: 'Скрыть',
  columnMenuUnsort: 'Отменить сортировку',
  columnMenuSortAsc: 'Сортировать по возрастанию',
  columnMenuSortDesc: 'Сортировать по убыванию',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} активных фильтров` : `${count} активный фильтр`,
  columnHeaderFiltersLabel: 'Показать фильтры',
  columnHeaderSortIconLabel: 'Сортировать',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} строк выбрано`
      : `${count.toLocaleString()} строка выбрана`,

  // Total row amount footer text
  footerTotalRows: 'Всего строк:',

  // Total visible row amount footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} из ${totalCount.toLocaleString()}`,

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Выбор',
  checkboxSelectionSelectAllRows: 'Выбрать все строки',
  checkboxSelectionUnselectAllRows: 'Отменить выбор всех строк',
  checkboxSelectionSelectRow: 'Выбрать строку',
  checkboxSelectionUnselectRow: 'Отменить выбор строки',

  // Boolean cell text
  booleanCellTrueLabel: 'да',
  booleanCellFalseLabel: 'нет',

  // Actions cell more text
  actionsCellMore: 'ещё',

  // Column pinning text
  pinToLeft: 'Закрепить слева',
  pinToRight: 'Закрепить справа',
  unpin: 'Открепить',

  // Tree Data
  treeDataGroupingHeaderName: 'Группа',
  treeDataExpand: 'показать дочерние элементы',
  treeDataCollapse: 'скрыть дочерние элементы',

  // Grouping columns
  groupingColumnHeaderName: 'Группа',
  groupColumn: (name) => `Группировать по ${name}`,
  unGroupColumn: (name) => `Отменить группировку по ${name}`,

  // Master/detail
  detailPanelToggle: 'Переключить детальную панель',
  expandDetailPanel: 'Развернуть',
  collapseDetailPanel: 'Свернуть',

  // Row reordering text
  rowReorderingHeaderName: 'Изменение порядка строк',

  // Aggregation
  aggregationMenuItemHeader: 'Агрегация',
  aggregationFunctionLabelSum: 'сумма',
  aggregationFunctionLabelAvg: 'среднее',
  aggregationFunctionLabelMin: 'минимум',
  aggregationFunctionLabelMax: 'максимум',
  aggregationFunctionLabelSize: 'размер',
};
